// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import Reload from '../_raw/ui/icon_reload.svg';
import withIconProps from '../withIconProps';

export default withIconProps(Reload);
